import React, { Component } from 'react';
import { Col, CardHeader, Modal, ModalBody, ModalFooter, TabContent, TabPane, FormGroup, Label, Input, Button } from 'reactstrap';
import LaddaButton, { EXPAND_LEFT } from 'react-ladda';

import RichTextEditor from 'react-rte';

import Config from '../../config';
import Lang from '../../languages';

import ImageUploader from '../../components/ImageUpload';
import GeoAutosuggest from '../../components/GeoAutosuggest'
import Map from "./FullMap";

import './Editor.css';

class EstablishmentsEditor extends Component {
 constructor(props) {
  super(props);

  this.setValue = this.setValue.bind(this);
  this.handleTabs = this.handleTabs.bind(this);
  this.handleSave = this.handleSave.bind(this);
  this.handleClose = this.handleClose.bind(this);
  this.handleChange = this.handleChange.bind(this);
  this.handleUpload = this.handleUpload.bind(this);
  this.handleLanguage = this.handleLanguage.bind(this);
  this.onPlaceSelected = this.onPlaceSelected.bind(this);

  this.state = {
   laddaloading: false,
   errMessage: false,
   editorMode: false,
   productTypes: [],
   monthSelector: null,
   languageSelector: Config.defaultLanguage,
   upload: {
    maxFileSize: 5242880,
    imgExtension: [".jpg", ".png", ".webp"],
    defaultImages: []
   }
  }
 }

 resetAll() {
  var classNames = {}
  var establishmentValues = { name: '', description: { [this.state.languageSelector]: RichTextEditor.createEmptyValue() }, full_address: '', latitude: 0, longitude: 0, pictures: [] }
  Object.keys(establishmentValues).map(function (key, value) { classNames[key] = "form-control" });
  this.setState({
   activeTab: '1',
   titleTab: Lang[this.props.session.language].Establishments.titles.editorTab1,
   laddaloading: false,
   errMessage: false,
   editorMode: false,
   mapZoom: 5,
   establishment: establishmentValues,
   classNames
  })
 }

 setValue(e) {
  var newEstablishment = this.state.establishment;
  newEstablishment[e.target.id] = e.target.value;
  this.setState({ establishment: newEstablishment });
 }

 handleTabs(tab) {
  switch (tab) {
   case '1': var title = Lang[this.props.session.language].Establishments.titles.editorTab1; break;
   case '2': var title = Lang[this.props.session.language].Establishments.titles.editorTab2; break;
  }

  this.setState({ titleTab: title, activeTab: tab });
 }

 handleSave() {
  var errorFileds = this.state.classNames;
  Object.keys(errorFileds).map(function (key, index) { errorFileds[key] = errorFileds[key].replace(' border border-danger', ''); });
  this.setState({ laddaloading: true, classNames: errorFileds });
  var establishment = JSON.parse(JSON.stringify(this.state.establishment));
  Object.keys(establishment.description).map(language => {
   establishment.description[language] = this.state.establishment.description[language]._cache.html
  })
  this.props.reqAPI(Config.apiURI + '/api/establishments', 'PUT', establishment).then((result) => {
   if (result.success) {
    this.props.onComplete(true);
    this.resetAll();
   } else {
    var errorFileds = this.state.classNames;
    result.failed.map((key) => { errorFileds[key] = errorFileds[key] + " border border-danger"; });
    this.setState({ laddaloading: false, errMessage: result.message, classNames: errorFileds });
   }
  }).catch((error) => {
   console.error(error);
   this.setState({ laddaloading: false });
  })
 }

 handleClose() {
  this.props.handleClose();
  this.resetAll();
 }

 onPlaceSelected(place) {
  var newEstablishment = this.state.establishment;
  newEstablishment.full_address = place.formatted_address;
  newEstablishment.latitude = place.geometry.location.lat;
  newEstablishment.longitude = place.geometry.location.lng;
  this.setState({ mapZoom: 15, establishment: newEstablishment });
 }

 handleChange(files) {
  const { pictures } = this.state.establishment;
  this.setState({
   ...this.state,
   establishment: {
    ...this.state.establishment,
    pictures: [...pictures, ...files]
   }
  });
 }

 handleUpload(pictures) {
  this.setState({
   ...this.state,
   establishment: {
    ...this.state.establishment,
    pictures: pictures
   }
  });
 };

 handleLanguage(e) {
  var newEstablishment = this.state.establishment;
  if (!newEstablishment.description[e.target.value]) newEstablishment.description[e.target.value] = RichTextEditor.createEmptyValue();
  else newEstablishment.description[e.target.value] = RichTextEditor.createValueFromString(newEstablishment.description[e.target.value].toString('html'), "html")
  this.setState({ establishment: newEstablishment, languageSelector: e.target.value });
 }


 componentWillMount() {
  this.resetAll();
 }

 componentWillUpdate() {
  if (this.props.establishment != null && !this.state.editorMode) {
   var description = this.props.establishment.description;
   if (description) {
    Object.keys(description).map((language, key) => {
     description[language] = RichTextEditor.createValueFromString(description[language].toString('html'), 'html')
    })
   } else {
    description = { [this.state.languageSelector]: RichTextEditor.createEmptyValue() }
   }

   this.setState({
    editorMode: true,
    mapZoom: 15,
    establishment: {
     ID: this.props.establishment.ID ? this.props.establishment.ID : '',
     name: this.props.establishment.name ? this.props.establishment.name : '',
     description: description,
     full_address: this.props.establishment.full_address ? this.props.establishment.full_address : '',
     latitude: this.props.establishment.latitude ? this.props.establishment.latitude : 0,
     longitude: this.props.establishment.longitude ? this.props.establishment.longitude : 0,
     pictures: this.props.establishment.pictures ? this.props.establishment.pictures : []
    }
   });
  }
 }

 render() {
  if (this.state.establishment === null) {
   return (<div />)
  } else {
   return (
    <Modal className="modal-xl ModalEstablishment" isOpen={this.props.open}>
     <CardHeader>
      <i className="fa fa-address-book-o"></i><strong>{this.state.titleTab}</strong>
      <select id="language" value={this.state.languageSelector} onChange={this.handleLanguage} className="ml-2">
       {
        Object.keys(Lang[this.props.session.language].languages).map((key, index) => {
         return (<option key={index} value={key}>{Lang[this.props.session.language].languages[key]}</option>)
        })
       }
      </select>
      <div className="card-actions bg-light">
       <Button disabled={this.state.activeTab !== '1' ? false : true} onClick={() => this.handleTabs('1')}><i className="fa fa-shopping-bag"></i></Button>
       <Button disabled={this.state.activeTab !== '2' ? false : true} onClick={() => this.handleTabs('2')}><i className="fa fa-picture-o"></i></Button>
      </div>
     </CardHeader>

     <ModalBody>

      <TabContent activeTab={this.state.activeTab}>
       <TabPane tabId="1">
        <FormGroup row>
         <Col xs="6">
          <FormGroup className="form-group-clean">
           <Label htmlFor="name">{Lang[this.props.session.language].Establishments.columns.name}</Label>
           <Input type="text" id="name" autoComplete="off" value={this.state.establishment.name} onChange={(e) => { this.setValue(e) }} placeholder={Lang[this.props.session.language].Establishments.placeholders.name} className={this.state.classNames.name} />
          </FormGroup>
         </Col>

         <Col xs="6">
          <FormGroup className="form-group-clean">
           <Label htmlFor="full_address">{Lang[this.props.session.language].Establishments.columns.full_address}</Label>
           <GeoAutosuggest {...this.props} value={this.state.establishment.full_address} placeholder={Lang[this.props.session.language].Establishments.placeholders.full_address} handleInputEL={() => { }} handleCallback={this.onPlaceSelected} className={this.state.classNames.full_address} />
          </FormGroup>
         </Col>
        </FormGroup>
        <FormGroup row>

         <Col xs="6">
          <FormGroup className="form-group-clean">
           <Label htmlFor="description">{Lang[this.props.session.language].Establishments.columns.description}</Label>
           <RichTextEditor
            className="RichTextEditor rounded-0"
            toolbarClassName="pb-0 px-2 pt-2 m-0"
            editorClassName=""
            value={this.state.establishment.description[this.state.languageSelector]}
            onChange={(value) => {
             value.toString('html');
             var newEstablishment = this.state.establishment;
             newEstablishment.description[this.state.languageSelector] = value;
             this.setState({ establishment: newEstablishment });
            }}
            toolbarConfig={{
             display: ['INLINE_STYLE_BUTTONS', 'BLOCK_TYPE_BUTTONS', 'LINK_BUTTONS', 'BLOCK_TYPE_DROPDOWN', 'HISTORY_BUTTONS'],
             INLINE_STYLE_BUTTONS: [
              { label: 'Bold', style: 'BOLD', className: 'custom-css-class' },
              { label: 'Italic', style: 'ITALIC' },
              { label: 'Underline', style: 'UNDERLINE' }
             ],
             BLOCK_TYPE_DROPDOWN: [
              { label: 'Normal', style: 'unstyled' },
              { label: 'Heading Large', style: 'header-one' },
              { label: 'Heading Medium', style: 'header-two' },
              { label: 'Heading Small', style: 'header-three' }
             ],
             BLOCK_TYPE_BUTTONS: [
              { label: 'UL', style: 'unordered-list-item' },
              { label: 'OL', style: 'ordered-list-item' }
             ]
            }}
           />
          </FormGroup>
         </Col>

         <Col xs="6">
          <FormGroup className="form-group-clean">
           <Map zoom={this.state.mapZoom} center={{ lat: parseFloat(this.state.establishment.latitude), lng: parseFloat(this.state.establishment.longitude) }} handleCallback={this.onPlaceSelected} height="300px" />
          </FormGroup>
         </Col>
        </FormGroup>
       </TabPane>

       <TabPane tabId="2">
        <ImageUploader
         withIcon={true}
         withLabel={true}
         withPreview={true}
         buttonText={Lang[this.props.session.language].Establishments.buttons.uploadPhoto}
         fileSizeError={"File size is too big!"}
         fileTypeError={"This extension is not supported!"}
         onChange={this.handleUpload}
         imgExtension={this.state.imgExtension}
         maxFileSize={this.state.maxFileSize}
         defaultImages={this.state.establishment.pictures}
        />
       </TabPane>

      </TabContent>
     </ModalBody>

     <ModalFooter>
      <div className="text-danger"><strong>{this.state.errMessage}</strong></div>
      <Button color="danger" onClick={this.handleClose}>{Lang[this.props.session.language].Establishments.buttons.closeEditor}</Button>
      <LaddaButton
       type="submit"
       onClick={this.handleSave}
       className="btn btn-success btn-ladda"
       data-style={EXPAND_LEFT}
       loading={this.state.laddaloading}>
       {this.state.editorMode ? Lang[this.props.session.language].Establishments.buttons.saveChanges : Lang[this.props.session.language].Establishments.buttons.createBtn}
      </LaddaButton>
     </ModalFooter>
    </Modal>
   )
  }
 }

}

export default EstablishmentsEditor;



// WEBPACK FOOTER //
// ./websources/views/Establishments/Editor.js